import { useQuery } from '@tanstack/react-query'
import type { TicketStatus } from '@kfolks/types'
import { ticketsApi } from '../api/tickets.api'
import { ticketsKeys } from './query-keys'

export interface UseAdminTicketsParams {
	status: TicketStatus | 'all'
	page: number
	limit: number
}

/**
 * Admin Tickets list query. Status `'all'` widens the filter to omit the
 * status param on the wire; any concrete `TicketStatus` is forwarded as-is.
 */
export function useAdminTickets({ status, page, limit }: UseAdminTicketsParams) {
	return useQuery({
		queryKey: ticketsKeys.adminList({ status, page }),
		queryFn: () =>
			ticketsApi.listAll({
				status: status === 'all' ? undefined : status,
				page,
				limit,
			}),
	})
}
